import React from "react";
import { EncryptedDescription } from "./MissionsContent.styled";
import { generateMixedGlitch } from "../../utils/glitch";

// Function to generate encrypted-looking text
export const generateEncryptedText = (length = 200) => {
  return generateMixedGlitch(length);
};

const EncryptedBlock = ({ length = 50 }) => {
  // Generate random length between length and length + 100

  return (
    <EncryptedDescription style={{ marginBottom: "1rem" }}>
      {generateEncryptedText(length)}
    </EncryptedDescription>
  );
};

export default EncryptedBlock;